import { useContext, createContext } from 'react';
var CardContext = createContext({
  padding: 0
});
var CardProvider = CardContext.Provider;
var useCardPadding = function useCardPadding() {
  return useContext(CardContext).padding;
};
export { CardProvider, useCardPadding };